import { getAuth } from '@services/auth';
import * as types from '../types';

const PROCESSES_API = {
  Corretor: 'GetPoliciesList',
  Tomador: 'GetPolicyHolderPoliciesList'
};

export const actionSucceeded = data => ({
  type: types.FETCH_PROCESSES_SUCCEEDED,
  payload: data
});

export const actionFailed = error => ({
  type: types.FETCH_PROCESSES_FAILED,
  payload: error
});

export const fetchProcesses = (params, userType = 'Corretor') => async (
  dispatch,
  getState,
  { PoliciesAPI }
) => {
  dispatch({ type: types.REQUEST_PROCESSES_DATA });
  const user = getAuth();
  const username = user ? user.username : '';
  const DEFAULT_QUERY = { page: 1, offset: 20, args: {} };
  const query = { ...DEFAULT_QUERY, ...params };
  let onError = [];

  const response = await PoliciesAPI[PROCESSES_API[userType]](
    query.page,
    query.offset,
    { ...query.args, username }
  ).catch(error => {
    onError = [{ error: error.data }];
    return dispatch(actionFailed(error));
  });
  if (response.data && !response.data.records) {
    return dispatch(actionFailed(''));
  }

  if (response.status === 200) {
    return dispatch(actionSucceeded(response.data));
  }

  return dispatch(actionFailed(onError));
};

export const loadingProcesses = isLoading => ({
  type: types.LOADING_PROCESSES,
  payload: isLoading
});
